import React, { FC, useCallback, useContext } from 'react'
import { GhostButton } from 'react-components'
import { ThemeContext } from 'styled-components'

import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'
import { ButtonTransport } from '@common/transports/deprecated-home-page-transport'
import { ButtonContainer } from './primary-faq-button-styles'

interface Props {
    button: ButtonTransport
}

const PrimaryFAQButton: FC<Props> = ({ button }) => {
    const theme = useContext(ThemeContext)

    const _handleClick = useCallback(() => {
        if (button.eventLabel) {
            AnalyticsService.trackClickEvent(homePageEventCategories.FAQ_SECTION, button.eventLabel)
        }
    }, [button.eventLabel])

    return (
        <ButtonContainer>
            <GhostButton
                href={button.url}
                padding="0.625rem 0.59375rem 0.6875rem"
                width={theme.layout.fill}
                onClick={_handleClick}
            >
                {button.text}
            </GhostButton>
        </ButtonContainer>
    )
}

export default PrimaryFAQButton
